<template>
  <div class="data-governance-page">
    <!-- 面包屑导航 -->
    <nav class="breadcrumb-nav">
      <router-link to="/">首页</router-link>
      <span class="separator">/</span>
      <router-link to="/consulting">咨询</router-link>
      <span class="separator">/</span>
      <span class="current">数据治理咨询</span>
    </nav>

    <!-- 1️⃣ Banner区 -->
    <section id="banner" class="section">
      <div class="banner">
        <div class="grid-2">
          <div>
            <h1>数据治理咨询</h1>
            <div class="banner-sub">构建统一标准、可信可用的数据治理体系。古杉数据数据治理咨询本质是帮助企业构建一套现代化的数据管理体系和运营模式，让数据成为企业真正可靠、可用、可管的战略资产，从而在数字化与AI时代建立持久的竞争优势。</div>
            <div class="banner-tags">
              <h2 class="banner-tag">战略与组织设计</h2>
              <h2 class="banner-tag">数据质量管理</h2>
              <h2 class="banner-tag">数据架构与平台</h2>
              <h2 class="banner-tag">合规、安全与AI就绪</h2>
              <h2 class="banner-tag">数据标准体系建设</h2>
              <h2 class="banner-tag">数据资产管理</h2>

            </div>
          </div>
          <div class="banner-visual">
            <div class="network-grid">
              <i class="fas fa-database"></i>
              <i class="fas fa-share-nodes" style="font-size: 120px;"></i>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 固定导航 -->
    <section class="nav-fixed">
      <div class="nav-container">
        <div class="nav-menu-inner">
          <a href="#banner" class="nav-item-inner" :class="{ active: currentSection === 'banner' }" @click.prevent="scrollTo('banner')">首页</a>
          <a href="#services" class="nav-item-inner" :class="{ active: currentSection === 'services' }" @click.prevent="scrollTo('services')">服务内容</a>
          <a href="#features" class="nav-item-inner" :class="{ active: currentSection === 'features' }" @click.prevent="scrollTo('features')">服务特点</a>
          <a href="#advantages" class="nav-item-inner" :class="{ active: currentSection === 'advantages' }" @click.prevent="scrollTo('advantages')">服务优势</a>
          <a href="#framework" class="nav-item-inner" :class="{ active: currentSection === 'framework' }" @click.prevent="scrollTo('framework')">咨询框架</a>
          <a href="#clients" class="nav-item-inner" :class="{ active: currentSection === 'clients' }" @click.prevent="scrollTo('clients')">成功客户</a>
          <a href="#topics" class="nav-item-inner" :class="{ active: currentSection === 'topics' }" @click.prevent="scrollTo('topics')">专题研究</a>
          <a href="#contact" class="nav-item-inner" :class="{ active: currentSection === 'contact' }" @click.prevent="scrollTo('contact')">预约咨询</a>
        </div>
      </div>
    </section>

    <!-- 2️⃣ 咨询服务内容模块（六大模块） -->
    <section id="services" class="section">
      <div class="container">
        <h2>数据治理咨询服务内容</h2>
        <div class="grid-3">
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-chess-board"></i></div>
            <h3>数据治理顶层设计</h3>
            <p>从战略高度规划数据治理愿景、目标与路径，设计治理组织架构与制度体系。业务蓝图、技术蓝图规划，指导后续数据建设。</p>
            <span class="feature-tag">交付物：数据现状诊断报告、业务蓝图、技术蓝图</span>
          </div>
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-ruler"></i></div>
            <h3>数据标准体系建设</h3>
            <p>建立企业级数据标准体系，包括数据元、指标、代码、通用编码，指标标准体系建设，确保数据定义统一。内部推动贯标。</p>
            <span class="feature-tag">交付物：企业级数据标准体系、指标标准体系</span>
          </div>
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-cubes"></i></div>
            <h3>主数据管理规划</h3>
            <p>主数据现状分析，识别核心主数据域，设计主数据模型、管理流程与系统集成方案。主数据集成及实施工作。</p>
            <span class="feature-tag">交付物：主数据咨询方案、主数据集成方案、切换方案</span>
          </div>
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-chart-line"></i></div>
            <h3>数据质量管理体系</h3>
            <p>围绕共享数据、主数据、重点业务场景，建立数据质量度量、监控、改进机制，提升数据可信度。推动数据质量改进POC项目。</p>
            <span class="feature-tag">交付物：数据质量报告框架、POC数据质量改进方案</span>
          </div>
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-coins"></i></div>
            <h3>数据资产盘点与价值评估</h3>
            <p>盘点数据资产，构建数据资产目录，评估数据价值与成本。识别给公司产生收益数据，形成高价值区数据，为资产入表奠定基础。</p>
            <span class="feature-tag">交付物：资产盘点清单、价值评估报告</span>
          </div>
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-people-arrows"></i></div>
            <h3>数据治理组织与制度设计</h3>
            <p>设计数据治理委员会、数据Owner等组织机制，配套管理制度，形成系列的制度文件、流程等。</p>
            <span class="feature-tag">交付物：组织制度手册、流程手册</span>
          </div>
        </div>
      </div>
    </section>

    <!-- 2️⃣ 第二层：服务特点 -->
    <section id="features" class="section">
      <div class="container">
        <h2>数据治理服务特点</h2>
        <div class="grid-4">
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-sitemap"></i></div>
            <h3>体系化方法</h3>
            <p>基于DMBOK、DCMM等数据管理领域的国际/国家标准，参考TOGAF企业架构方法，形成端到端方法论。</p>
          </div>
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-balance-scale"></i></div>
            <h3>监管导向适配</h3>
            <p>深度理解央国企监管及合规要求，围绕国资监管、经营管理、核心重点场景进行治理适配，满足业务及监管要求。</p>
          </div>
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-toolbox"></i></div>
            <h3>工具+咨询结合</h3>
            <p>提供数据治理平台配套，实现制度线上化、流程自动化。改进只有咨询文档，无落地支撑现实，让质量改进更有感知。</p>
          </div>
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-check-circle"></i></div>
            <h3>可落地可评估（Agent 纳入）</h3>
            <p>基于客户信息化现状，规划治理路径，设计每阶段可量化评估指标，确保治理成效可见。纳入AI Agent,确保效果。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 3️⃣ 服务优势模块 -->
    <section id="advantages" class="section">
      <div class="container">
        <h2>服务优势</h2>
        <div class="grid-2">
          <div>
            <p style="font-size: 18px; margin-bottom: 20px;">古杉数据在数据管理、数据治理及分析应用领域拥有深厚积淀，尤其擅长特大型头部外资企业、央企、国企及集团企业的治理体系设计与落地。</p>
            <ul style="list-style: none;">
              <li><i class="fas fa-check-circle" style="color: var(--primary-blue); margin-bottom: 20px; margin-right: 12px;"></i>丰富央企/集团治理经验：服务超过30家央企及二级单位</li>
              <li><i class="fas fa-check-circle" style="color: var(--primary-blue); margin-bottom: 20px; margin-right: 12px;"></i>已验证标准化交付体系：30+治理文档模板，快速复用</li>
              <li><i class="fas fa-check-circle" style="color: var(--primary-blue); margin-bottom: 20px; margin-right: 12px;"></i>与审计/风控/财务/供应链深度融合：打通数据治理与合规风控</li>
              <li><i class="fas fa-check-circle" style="color: var(--primary-blue); margin-bottom: 20px; margin-right: 12px;"></i>与数字化转型战略联动：治理为数字化提供基础保障</li>
                            <li><i class="fas fa-check-circle" style="color: var(--primary-blue); margin-bottom: 20px; margin-right: 12px;"></i>专注行业经验：能源、电力、制造业、零售快消品（部分）</li>
            </ul>
          </div>
          <div class="stats-grid">
            <div class="stat-item">
              <div class="stat-number" ref="stat1">0</div>
              <div>服务行业数量</div>
            </div>
            <div class="stat-item">
              <div class="stat-number" ref="stat2">0</div>
              <div>集团级企业</div>
            </div>
            <div class="stat-item">
              <div class="stat-number" ref="stat3">0%</div>
              <div>项目成功率</div>
            </div>
            <div class="stat-item">
              <div class="stat-number" ref="stat4">0%</div>
              <div>数据质量提升</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 4️⃣ 咨询框架（五阶段） -->
    <section id="framework" class="section">
      <div class="container">
        <h2>数据治理五阶段框架</h2>
        <div class="timeline-horizontal">
          <div class="timeline-step" @click="activeStep = 1">
            <div class="timeline-marker">1</div>
            <div class="timeline-title">现状诊断</div>
          </div>
          <div class="timeline-step" @click="activeStep = 2">
            <div class="timeline-marker">2</div>
            <div class="timeline-title">体系设计</div>
          </div>
          <div class="timeline-step" @click="activeStep = 3">
            <div class="timeline-marker">3</div>
            <div class="timeline-title">平台与机制建设</div>
          </div>
          <div class="timeline-step" @click="activeStep = 4">
            <div class="timeline-marker">4</div>
            <div class="timeline-title">推广实施</div>
          </div>
          <div class="timeline-step" @click="activeStep = 5">
            <div class="timeline-marker">5</div>
            <div class="timeline-title">持续运营</div>
          </div>
        </div>
        <div class="step-detail" :class="{ active: activeStep === 1 }">
          <h3>现状诊断阶段</h3>
          <p>任务项：数据成熟度评估 · 数据资产盘点 · 数据问题诊断</p>
          <p>交付物：数据治理成熟度报告、数据资产清单、问题诊断书</p>
        </div>
        <div class="step-detail" :class="{ active: activeStep === 2 }">
          <h3>体系设计阶段</h3>
          <p>数据标准体系 · 数据架构规划 · 治理制度设计</p>
          <p>交付物：标准体系框架、架构蓝图、制度草案</p>
        </div>
        <div class="step-detail" :class="{ active: activeStep === 3 }">
          <h3>平台与机制建设</h3>
          <p>主数据管理设计 · 数据质量规则设计 · 元数据管理规划</p>
          <p>交付物：平台选型建议、技术规范</p>
        </div>
        <div class="step-detail" :class="{ active: activeStep === 4 }">
          <h3>推广实施</h3>
          <p>组织机制落地 · 数据责任体系建立 · 试点推广</p>
          <p>交付物：试点成果报告、推广计划</p>
        </div>
        <div class="step-detail" :class="{ active: activeStep === 5 }">
          <h3>持续运营</h3>
          <p>数据质量监控 · 数据资产价值评估 · 治理绩效评估</p>
          <p>交付物：运营指标体系和评估报告</p>
        </div>
        <!--
        <div style="text-align: center;">
          <a href="#" class="download-pdf" @click.prevent="downloadPdf"><i class="fas fa-download"></i> 下载方法论PDF</a>
        </div>
         -->
      </div>
    </section>

    <!-- 5️⃣ 成功客户列表 -->
    <section id="clients" class="section">
      <div class="container">
        <h2>成功客户</h2>
        <div class="industry-filter">
          <span class="filter-btn" :class="{ active: activeFilter === 'all' }" @click="activeFilter = 'all'">全部</span>
          <span class="filter-btn" :class="{ active: activeFilter === 'energy' }" @click="activeFilter = 'energy'">能源电力</span>
          <span class="filter-btn" :class="{ active: activeFilter === 'finance' }" @click="activeFilter = 'finance'">金融保险</span>
          <span class="filter-btn" :class="{ active: activeFilter === 'manufacturing' }" @click="activeFilter = 'manufacturing'">制造业</span>
          <span class="filter-btn" :class="{ active: activeFilter === 'government' }" @click="activeFilter = 'government'">政府单位</span>
        </div>
        <div class="logo-wall">
          <div v-for="client in filteredClients" :key="client.name" class="logo-item">
            {{ client.name }}
            <div class="logo-tooltip">{{ client.desc }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 6️⃣ 专业专题模块 -->
    <section id="topics" class="section">
      <div class="container">
        <h2>数据治理专题研究</h2>
        <p style="margin-bottom: 30px;">来自「数据决策与企业数字化转型」公众号精选内容</p>
        <div class="grid-3">
          <div class="topic-card" @click="openArticle('https://mp.weixin.qq.com/s/AO9UOJu03CJl75TS1WuhjA')">
            <div class="topic-meta">
              <span class="topic-tag">数据标准</span>
            </div>
            <h3>基础数据标准落地的两种策略</h3>
            <p style="color: #5f6a7d;">探讨基础数据标准在企业中的落地路径与实施策略。</p>
            <span class="read-link">阅读专题 →</span>
          </div>
          <div class="topic-card" @click="openArticle('https://mp.weixin.qq.com/s/z-lqv1VSoBj9oQbgd-PPaQ')">
            <div class="topic-meta">
              <span class="topic-tag">数据标准</span>
            </div>
            <h3>数据治理实施合集-01-数据标准实践(02)-标准制定贯标及发布更新</h3>
            <p style="color: #5f6a7d;">数据标准的制定、贯标流程及持续发布更新机制。</p>
            <span class="read-link">阅读专题 →</span>
          </div>
          <div class="topic-card" @click="openArticle('https://mp.weixin.qq.com/s/rcnu3xShxHrthe0ThhPuGg')">
            <div class="topic-meta">
              <span class="topic-tag">主数据</span>
            </div>
            <h3>主数据管理：企业数据治理"基建"如何设计？</h3>
            <p style="color: #5f6a7d;">解析企业主数据管理的架构设计与实施要点。</p>
            <span class="read-link">阅读专题 →</span>
          </div>
          <div class="topic-card" @click="openArticle('https://mp.weixin.qq.com/s/TbOsXpkJpOx9O42zF-v9YQ')">
            <div class="topic-meta">
              <span class="topic-tag">治理实践</span>
            </div>
            <h3>财务业务流程优化解决数据不一致问题</h3>
            <p style="color: #5f6a7d;">通过业务流程优化手段解决财务数据不一致的治理实践。</p>
            <span class="read-link">阅读专题 →</span>
          </div>
          <div class="topic-card" @click="openArticle('https://mp.weixin.qq.com/s/yHB1AgAkn_-_SvTGU0U_qg')">
            <div class="topic-meta">
              <span class="topic-tag">数据质量</span>
            </div>
            <h3>高质量数据集解读汇总</h3>
            <p style="color: #5f6a7d;">高质量数据集的标准、解读与实践汇总。</p>
            <span class="read-link">阅读专题 →</span>
          </div>
          <div class="topic-card" @click="openArticle('https://mp.weixin.qq.com/s/aAWIDA-0G0EUDa3-3pQ2vA')">
            <div class="topic-meta">
              <span class="topic-tag">数据资产</span>
            </div>
            <h3>数据资产入表实施步骤及相关政策</h3>
            <p style="color: #5f6a7d;">数据资产入表的实施路径与相关政策解读。</p>
            <span class="read-link">阅读专题 →</span>
          </div>
        </div>
        <div class="load-more">
          <button class="btn-load-more" @click="loadMore">加载更多</button>
        </div>
      </div>
    </section>

    <!-- 7️⃣ 底部转化模块 -->
    <section id="contact" class="section cta-section">
      <h2>预约咨询</h2>
      <div class="cta-inner">
        <h3 class="cta-heading">构建可信、统一的数据治理与 AI 治理体系</h3>
        <p class="cta-sub">当前已服务 100+ 央企国企，覆盖能源、电力、制造、金融等重点行业</p>
        <div class="cta-actions">
          <button class="cta-btn cta-btn--primary" @click="showModal = true">
            <i class="fas fa-calendar-check"></i>
            预约咨询
          </button>
          <button class="cta-btn cta-btn--outline" @click="showQrCode">
            <i class="fab fa-weixin"></i>
            扫码添加顾问
          </button>
        </div>
        <div class="cta-contact-row">
          <span><i class="fas fa-phone-alt"></i> 185-1017-6330</span>
          <span class="divider">|</span>
          <span><i class="fas fa-envelope"></i> pmo@gushandata.cn</span>
          <span class="divider">|</span>
          <span><i class="fas fa-clock"></i> 1小时内响应 · 严格保密</span>
        </div>
      </div>
    </section>

    <!-- 预约咨询弹窗 -->
    <transition name="modal-fade">
    <div class="modal-overlay" v-if="showModal" @click.self="showModal = false">
      <div class="modal-container appointment-modal">
        <div class="modal-header">
          <div class="modal-header-icon"><i class="fas fa-calendar-check"></i></div>
          <div>
            <h3 class="modal-title">预约专家一对一咨询</h3>
            <p class="modal-subtitle">我们将在 1 小时内安排资深顾问与您联系</p>
          </div>
          <button class="modal-close-btn" @click="showModal = false"><i class="fas fa-times"></i></button>
        </div>
        <form class="appt-form" @submit.prevent="submitForm">
          <div class="form-row">
            <div class="form-group">
              <label>姓名 <span class="required">*</span></label>
              <input type="text" placeholder="请输入您的姓名" required />
            </div>
            <div class="form-group">
              <label>联系电话 <span class="required">*</span></label>
              <input type="tel" placeholder="便于顾问联系您" required />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>公司名称</label>
              <input type="text" placeholder="您所在的公司" />
            </div>
            <div class="form-group">
              <label>职位</label>
              <input type="text" placeholder="您的职位/部门" />
            </div>
          </div>
          <div class="form-group">
            <label>咨询方向</label>
            <select>
              <option value="">-- 请选择咨询方向 --</option>
              <option>顶层设计 / 数据战略规划</option>
              <option>数据标准与数据质量</option>
              <option>主数据管理</option>
              <option>数据资产盘点 / DCMM 评估</option>
              <option>AI 治理与大模型应用</option>
              <option>其他（请备注）</option>
            </select>
          </div>
          <div class="form-group">
            <label>补充说明</label>
            <textarea rows="2" placeholder="简述您的业务场景或待解决的问题（可选）"></textarea>
          </div>
          <button type="submit" class="form-submit-btn">
            <i class="fas fa-paper-plane"></i> 提交预约
          </button>
          <p class="form-privacy"><i class="fas fa-lock"></i> 您的信息将严格保密，仅用于本次咨询联系</p>
        </form>
      </div>
    </div>
    </transition>

    <!-- 扫码添加顾问弹窗 -->
    <transition name="modal-fade">
    <div class="modal-overlay" v-if="showQrModal" @click.self="showQrModal = false">
      <div class="modal-container qr-modal">
        <div class="modal-header">
          <div class="modal-header-icon qr-header-icon"><i class="fab fa-weixin"></i></div>
          <div>
            <h3 class="modal-title">扫码添加顾问</h3>
            <p class="modal-subtitle">加微信，获取一对一专属服务</p>
          </div>
          <button class="modal-close-btn" @click="showQrModal = false"><i class="fas fa-times"></i></button>
        </div>
        <div class="qr-grid">
          <div class="qr-card" v-for="(img, idx) in qrImages" :key="idx">
            <div class="qr-img-wrap">
              <img v-if="img" :src="img" :alt="'顾问二维码 ' + (idx+1)" class="qr-img" />
              <div v-else class="qr-placeholder"><i class="fab fa-weixin"></i><span>二维码占位</span></div>
            </div>
            <div class="qr-card-label">扫码添加「数据治理」专属顾问</div>
            <div class="qr-scan-hint"><i class="fas fa-qrcode"></i> 扫一扫即可添加</div>
          </div>
        </div>
        <p class="qr-footer-tip">或致电 <strong>185-1017-6330</strong> 直接预约顶层顾问服务</p>
      </div>
    </div>
    </transition>

  </div>
</template>

<script>
export default {
  name: 'ConsultDetailDataGovernance',
  data() {
    return {
      currentSection: 'banner',
      activeStep: 1,
      activeFilter: 'all',
      showModal: false,
      // 控制扫码弹窗（两个二维码占位）
      showQrModal: false,
      // 预留两个二维码，填入图片路径即可展示
      qrImages: [require('@/assets/img/qr_gu.jpg'), require('@/assets/img/qr_sang.jpg')],
      clients: [
        { name: '国家能源集团', industry: 'energy', desc: '数据标准体系建设项目' },
        { name: '中国建设银行', industry: 'finance', desc: '主数据管理咨询' },
        { name: '中国一汽', industry: 'manufacturing', desc: '数据质量提升' },
        { name: '南方电网', industry: 'energy', desc: '数据资产盘点' },
        { name: '国家卫健委', industry: 'government', desc: '数据治理顶层设计' },
        { name: '中国人寿', industry: 'finance', desc: '数据治理组织设计' }
      ]
    }
  },
  computed: {
    filteredClients() {
      if (this.activeFilter === 'all') return this.clients
      return this.clients.filter(c => c.industry === this.activeFilter)
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.animateNumbers()
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    scrollTo(id) {
      const el = document.getElementById(id)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    },
    handleScroll() {
      const sections = this.$el.querySelectorAll('.section')
      const scrollPos = window.pageYOffset + 100
      sections.forEach(section => {
        const top = section.offsetTop - 70
        const bottom = top + section.offsetHeight
        if (scrollPos >= top && scrollPos < bottom && section.id) {
          this.currentSection = section.id
        }
      })
    },
    animateNumber(element, target, suffix) {
      let current = 0
      const increment = target / 80
      const timer = setInterval(() => {
        current += increment
        if (current >= target) {
          element.innerText = target + suffix
          clearInterval(timer)
        } else {
          element.innerText = Math.floor(current) + suffix
        }
      }, 16)
    },
    animateNumbers() {
      this.$nextTick(() => {
        const stats = [
          { ref: 'stat1', target: 12, suffix: '' },
          { ref: 'stat2', target: 85, suffix: '' },
          { ref: 'stat3', target: 98, suffix: '%' },
          { ref: 'stat4', target: 65, suffix: '%' }
        ]
        stats.forEach(stat => {
          if (this.$refs[stat.ref]) {
            this.animateNumber(this.$refs[stat.ref], stat.target, stat.suffix)
          }
        })
      })
    },
    downloadPdf() {
      console.log('PDF下载点击埋点')
      alert('PDF下载功能已触发，可在此处集成真实下载逻辑。')
    },
    submitForm() {
      alert('表单已提交')
      this.showModal = false
    },
    showQrCode() {
      // 打开扫码弹窗，显示预留的两个二维码
      this.showQrModal = true
    },
    loadMore() {
      this.$router.push('/consulting/data-governance/articles')
    },
    openArticle(url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
/* 面包屑 */
.breadcrumb-nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 24px;
  font-size: 14px;
  color: #5f6a7d;
}
.breadcrumb-nav a {
  color: #1F3F8F;
  text-decoration: none;
}
.breadcrumb-nav a:hover {
  text-decoration: underline;
}
.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #ccc;
}
.breadcrumb-nav .current {
  color: #2B2F3A;
}

.data-governance-page {
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  background-color: #ffffff;
  color: #2B2F3A;
  line-height: 1.6;
  --primary-blue: #1F3F8F;
  --deep-indigo: #0E1F52;
  --light-porcelain: #EAF0FB;
  --bg-light: #f5f7fa;
  --text-dark: #2B2F3A;
  --card-shadow: 0 12px 28px rgba(0,10,30,0.04), 0 4px 16px rgba(31,63,143,0.08);
  --border-light: #e9edf4;
  --nav-height: 60px;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}

/* 固定导航 */
.nav-fixed {
  position: sticky;
  top: 60px;
  left: 0;
  width: 100%;
  background-color: white;
  box-shadow: 0 4px 20px rgba(0,0,0,0.02);
  z-index: 999;
  border-bottom: 1px solid rgba(31,63,143,0.1);
  height: var(--nav-height);
  backdrop-filter: blur(8px);
  background: rgba(255,255,255,0.9);
}
.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nav-menu-inner {
  display: flex;
  gap: 8px;
  background-color: #f5f7fa;
  padding: 4px;
  border-radius: 40px;
}
.nav-item-inner {
  padding: 8px 20px;
  font-size: 15px;
  font-weight: 500;
  color: #2B2F3A;
  border-radius: 32px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  background-color: transparent;
  border: none;
  white-space: nowrap;
}
.nav-item-inner:hover {
  background-color: #EAF0FB;
  color: #1F3F8F;
}
.nav-item-inner.active {
  background-color: #1F3F8F;
  color: white;
  font-weight: 600;
  box-shadow: 0 4px 10px rgba(31,63,143,0.2);
}

/* 通用样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 16px;
  
}



@keyframes sectionFadeIn {
  to { opacity: 1; transform: translateY(0); }
}

h1 {
  font-size: 42px;
  font-weight: 700;
  color: white;
  margin-bottom: 24px;
  letter-spacing: -0.02em;
  line-height: 1.2;
}
h2 {
  font-size: 28px;
  font-weight: 700;
  color: var(--deep-indigo);
  margin-bottom: 40px;
  letter-spacing: -0.01em;
  position: relative;
  display: inline-block;
}
h2:after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 60px;
  height: 3px;
  background-color: var(--primary-blue);
  border-radius: 4px;
}
h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
  color: var(--deep-indigo);
}

/* Banner区 */
.banner {
  background: linear-gradient(135deg, #1F3F8F 0%, #0E1F52 100%);
  border-radius: 32px;
  padding: 60px 48px;
  position: relative;
  overflow: hidden;
  margin-top: 20px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.banner::before {
  content: '';
  position: absolute;
  top: -30%;
  right: -10%;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(234,240,251,0.1) 0%, transparent 70%);
  border-radius: 50%;
  z-index: 0;
}
.banner .grid-2 {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: center;
}
.banner-sub {
  font-size: 18px;
  color: rgba(255,255,255,0.9);
  max-width: 550px;
  margin-bottom: 24px;
}
.banner-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 20px 0;
}
.banner-tag {
  background: rgba(255,255,255,0.15);
  color: white;
  padding: 6px 18px;
  border-radius: 40px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid rgba(255,255,255,0.2);
  backdrop-filter: blur(4px);
  transition: all 0.3s;
}
.banner-tag:hover {
  background: rgba(255,255,255,0.25);
  transform: translateY(-2px);
}
.banner-visual {
  display: flex;
  justify-content: center;
  align-items: center;
}
.network-grid {
  width: 100%;
  max-width: 400px;
  height: 280px;
  background: rgba(255,255,255,0.05);
  border-radius: 24px;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255,255,255,0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.network-grid i {
  font-size: 100px;
  color: rgba(255,255,255,0.2);
  position: absolute;
}

/* 卡片网格 */
.grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}
.grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}
.grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
}
.service-card {
  background: white;
  border-radius: 16px;
  padding: 28px 24px;
  box-shadow: var(--card-shadow);
  transition: all 0.3s ease;
  border: 1px solid rgba(31,63,143,0.05);
  cursor: pointer;
}
.service-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 40px rgba(31,63,143,0.12);
}

.read-link {
  margin-top: auto;
  padding-top: 16px;
  text-align: right;
  color: #1F3F8F;
  font-size: 14px;
  font-weight: 600;
  transition: color 0.3s;
}


.load-more {
  text-align: center;
  margin-top: 40px;
}
.btn-load-more {
  background: transparent;
  color: var(--primary-blue);
  border: 1px solid var(--primary-blue);
  padding: 14px 36px;
  border-radius: 60px;
  font-weight: 600;
  transition: 0.3s;
  cursor: pointer;
  font-size: 16px;
}
.btn-load-more:hover {
  background: var(--light-porcelain);
}


.card-icon {
  width: 56px;
  height: 56px;
  background: var(--light-porcelain);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-blue);
  font-size: 28px;
  margin-bottom: 20px;
}
.feature-tag {
  display: inline-block;
  background: var(--light-porcelain);
  padding: 4px 12px;
  border-radius: 40px;
  font-size: 13px;
  margin-right: 8px;
  margin-top: 12px;
}

/* 数字统计 */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}
.stat-item {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: var(--card-shadow);
  text-align: center;
}
.stat-number {
  font-size: 42px;
  font-weight: 700;
  color: var(--primary-blue);
  line-height: 1.2;
}

/* 时间轴五阶段 */
.timeline-horizontal {
  display: flex;
  justify-content: space-between;
  margin: 40px 0;
  position: relative;
}
.timeline-step {
  flex: 1;
  text-align: center;
  position: relative;
  cursor: pointer;
}
.timeline-marker {
  width: 40px;
  height: 40px;
  background: var(--primary-blue);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  font-weight: 600;
  transition: all 0.3s;
}
.timeline-step:hover .timeline-marker {
  transform: scale(1.1);
  background: var(--deep-indigo);
}
.timeline-title {
  font-weight: 600;
  margin-bottom: 8px;
}
.step-detail {
  background: var(--light-porcelain);
  border-radius: 16px;
  padding: 24px;
  margin-top: 30px;
  display: none;
}
.step-detail.active {
  display: block;
}
.download-pdf {
  display: inline-block;
  background: var(--primary-blue);
  color: white;
  padding: 12px 28px;
  border-radius: 40px;
  text-decoration: none;
  margin-top: 20px;
  transition: 0.3s;
}
.download-pdf:hover {
  background: #0e3170;
}

/* Logo墙 + 筛选 */
.industry-filter {
  display: flex;
  gap: 12px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}
.filter-btn {
  padding: 8px 24px;
  border-radius: 40px;
  background: white;
  border: 1px solid var(--border-light);
  cursor: pointer;
  transition: all 0.3s;
}
.filter-btn.active, .filter-btn:hover {
  background: var(--primary-blue);
  color: white;
}
.logo-wall {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;
  background: var(--bg-light);
  padding: 40px;
  border-radius: 32px;
}
.logo-item {
  background: white;
  padding: 16px 32px;
  border-radius: 60px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(0,0,0,0.02);
  transition: all 0.3s;
  cursor: pointer;
  border: 1px solid rgba(31,63,143,0.1);
  position: relative;
}
.logo-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(31,63,143,0.15);
}
.logo-tooltip {
  display: none;
  background: var(--deep-indigo);
  color: white;
  padding: 8px 16px;
  border-radius: 40px;
  font-size: 14px;
  margin-top: 8px;
  white-space: nowrap;
}
.logo-item:hover .logo-tooltip {
  display: block;
}

/* 专题卡片 */
.topic-card {
  background: white;
  border-radius: 16px;
  padding: 28px;
  box-shadow: var(--card-shadow);
  transition: all 0.3s;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}
.topic-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 40px rgba(31,63,143,0.12);
}
.topic-meta {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  color: #5f6a7d;
  font-size: 14px;
}
.topic-tag {
  background: var(--light-porcelain);
  padding: 4px 12px;
  border-radius: 40px;
  font-size: 12px;
}

/* ============ CTA 底部转化区 ============ */
.cta-section {
  margin-bottom: 60px;
}
.cta-inner {
  background: linear-gradient(135deg, #EAF0FB 0%, #F6F8FC 100%);
  border: 1px solid #D6E2F5;
  border-radius: 24px;
  padding: 48px 40px;
  text-align: center;
  color: #0E1F52;
  box-shadow: 0 8px 32px rgba(14,31,82,0.08);
}
.cta-badge {
  display: inline-block;
  background: rgba(31,63,143,0.08);
  border: 1px solid rgba(31,63,143,0.18);
  color: #1F3F8F;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 14px;
  border-radius: 20px;
  margin-bottom: 18px;
  letter-spacing: 0.6px;
}
.cta-heading {
  font-size: 24px;
  font-weight: 700;
  color: #0E1F52;
  margin-bottom: 10px;
  line-height: 1.45;
}
.cta-sub {
  font-size: 14px;
  color: #5A5E66;
  margin-bottom: 32px;
}
.cta-actions {
  display: flex;
  gap: 14px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 24px;
}
.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  border-radius: 50px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.25s;
  text-decoration: none;
}
.cta-btn--primary {
  background: #1F3F8F;
  color: #fff;
}
.cta-btn--primary:hover {
  background: #0E1F52;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(14,31,82,0.22);
}
.cta-btn--outline {
  background: #fff;
  color: #1F3F8F;
  border: 2px solid #1F3F8F;
}
.cta-btn--outline:hover {
  background: #EAF0FB;
  border-color: #0E1F52;
  color: #0E1F52;
  transform: translateY(-2px);
}
.cta-contact-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
  color: #7B8794;
  font-size: 12px;
}
.cta-contact-row i { margin-right: 4px; color: #1F3F8F; }
.cta-contact-row .divider { color: #CBD3E0; }

/* ============ 弹窗通用 ============ */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(11,26,51,0.65);
  backdrop-filter: blur(4px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.modal-container {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 420px;
  box-shadow: 0 20px 60px rgba(14,31,82,0.22);
  overflow: hidden;
}

/* 弹窗头部 */
.modal-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 18px 22px 16px;
  border-bottom: 1px solid #EEF1F8;
  position: relative;
}
.modal-header-icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 12px;
  background: #EAF0FB;
  color: #1F3F8F;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.qr-header-icon {
  background: #e8f5e9;
  color: #07c160;
}
.modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #0E1F52;
  margin: 0 0 4px;
}
.modal-subtitle {
  font-size: 13px;
  color: #7b8794;
  margin: 0;
}
.modal-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: #F4F6FB;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #5f6a7d;
  font-size: 14px;
  transition: background 0.2s;
}
.modal-close-btn:hover { background: #e2e8f4; }

/* 预约表单 */
.appt-form {
  padding: 16px 22px 22px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
@media (max-width: 480px) {
  .form-row { grid-template-columns: 1fr; }
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.form-group label {
  font-size: 13px;
  font-weight: 600;
  color: #2B2F3A;
}
.form-group .required { color: #e55353; }
.form-group input,
.form-group select,
.form-group textarea {
  padding: 8px 12px;
  border: 1.5px solid #E0E6F0;
  border-radius: 8px;
  font-size: 13px;
  color: #2B2F3A;
  background: #FAFBFD;
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;
  resize: vertical;
}
.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: #1F3F8F;
  box-shadow: 0 0 0 3px rgba(31,63,143,0.1);
  background: #fff;
}
.form-submit-btn {
  width: 100%;
  padding: 11px;
  background: #1F3F8F;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.2s, transform 0.2s;
  margin-top: 4px;
}
.form-submit-btn:hover {
  background: #0e3170;
  transform: translateY(-1px);
}
.form-privacy {
  text-align: center;
  font-size: 12px;
  color: #9ca3af;
  margin: -4px 0 0;
}
.form-privacy i { margin-right: 4px; }

/* 二维码弹窗 */
.qr-modal { max-width: 560px; }
.qr-grid {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  padding: 24px 28px;
}
.qr-card {
  flex: 1;
  min-width: 180px;
  max-width: 220px;
  background: #F8FAFF;
  border-radius: 16px;
  border: 1px solid #E0E8F8;
  padding: 20px 16px 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.qr-img-wrap {
  width: 160px;
  height: 160px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #dde5f5;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qr-img { width: 100%; height: 100%; object-fit: cover; display: block; }
.qr-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #9ca3af;
  font-size: 13px;
}
.qr-placeholder i { font-size: 36px; color: #07c160; opacity: 0.5; }
.qr-card-label {
  font-size: 13px;
  font-weight: 600;
  color: #0E1F52;
  line-height: 1.4;
}
.qr-scan-hint {
  font-size: 12px;
  color: #9ca3af;
}
.qr-scan-hint i { margin-right: 4px; }
.qr-footer-tip {
  text-align: center;
  font-size: 13px;
  color: #7b8794;
  padding: 0 28px 22px;
  margin: 0;
}
.qr-footer-tip strong { color: #0E1F52; }

/* 弹窗入场动画 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}
.modal-fade-enter-active .modal-container,
.modal-fade-leave-active .modal-container {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to { opacity: 0; }
.modal-fade-enter-from .modal-container,
.modal-fade-leave-to .modal-container {
  transform: translateY(24px) scale(0.97);
  opacity: 0;
}

/* 通用样式 */
.section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 16px;
}

/* 响应式 */
@media (max-width: 992px) {
  .grid-4 { grid-template-columns: repeat(2, 1fr); }
  .grid-3 { grid-template-columns: repeat(2, 1fr); }
  .grid-2 { grid-template-columns: 1fr; }
  .banner .grid-2 { grid-template-columns: 1fr; }
  .timeline-horizontal { flex-wrap: wrap; }
}
@media (max-width: 640px) {
  .grid-4, .grid-3 { grid-template-columns: 1fr; }
  .nav-menu-inner { flex-wrap: wrap; height: auto; }
}
</style>
